










































import Vue from 'vue';

import Accordion from "./Accordion.vue"
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";
import {IJourneyDetails} from "./JourneyDetails";
import {CrsConverter} from "./CrsConverter";
import RefundUtil from "./RefundUtil";
import {IRefundSuccess} from "./IRefundSuccess";

@Component({
    components: {
        Accordion
    }
})
export default class InstantRefundOffer extends Vue {
    @Prop() data: IRefundStatusJourney;
    @Prop() details: IJourneyDetails;
    @Prop() crsConverter: CrsConverter;
    @Prop() currencyFormatter: Intl.NumberFormat;
    @Prop() accordionTitle: string;
    @Prop() canAppeal: boolean;
    @Prop() dryRunRefund: IRefundSuccess;

    refundUtil: RefundUtil = new RefundUtil();
    loading: boolean = false;
}
